import { createI18n } from 'vue-i18n';
import { forEach, includes } from 'lodash';
import { getCookie } from '../utils';
import zh from './lang/zh';
import en from './lang/en';
import ko from './lang/ko';
import id from './lang/id';

const availableLocale = ['zh', 'en', 'ko', 'id'];

let defaultLangStr = navigator.language;
let defaultLang = 'zh';

if (defaultLangStr.indexOf('en') >= 0) {
  defaultLang = 'en';
}

const query = location.search.substr(1);
let queryObj = {};

if (query) {
  forEach(query.split('&'), (item) => {
    const tempArr = item.split('=');
    queryObj[tempArr[0]] = tempArr[1];
  });
}

let locale = includes(availableLocale, queryObj['locale'])
  ? queryObj['locale']
  : defaultLang;

if (queryObj['locale']) {
  locale = queryObj['locale']
} else {
  locale = localStorage.getItem('lang') || locale;
}

locale = getCookie('lang') || locale;

export default createI18n({
  // globalInjection: true,
  legacy: false, // you must set `false`, to use Composition API
  locale: locale,
  messages: { en, zh, ko, id },
});
